<script setup async lang="ts">
import { TooltipProvider } from '@/components/ui/tooltip'
import { Toaster } from 'vue-sonner'
import 'vue-sonner/style.css'
import ModalWindow from '~/core/ModalWindow.vue'
import { useLayoutState } from '~/layout-state'

const { stack, closeById } = useModal()
const { layout, requireAuth, shouldAuthorize } = useLayoutState()

if (shouldAuthorize.value) {
  await requireAuth()
}
</script>

<template>
  <TooltipProvider>
    <NuxtLayout :name="layout" />
    <ModalWindow :stack="stack" :closeById="closeById" />
    <Toaster position="bottom-right" />
  </TooltipProvider>
</template>
